import { useCallback, useMemo, useState } from "react";
import { GeoJSON, Marker, Pane, Polyline, Tooltip } from "react-leaflet";
import { divIcon, icon, MarkerCluster, point } from "leaflet";

import { Box, Card, Stack, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useCameras from "Hooks/useCamera";

import { renderToStaticMarkup } from "react-dom/server";

import Icon from "Components/Icon";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";
import { selectCamera } from "Redux/cameraSlice";
import MarkerClusterGroup from "react-leaflet-cluster";
import { CAMERA_TYPES } from "Constants/Stations";

const ICON_SIZE = 22;

export default function CameraMarkerCluster() {
  const dispatch = useAppDispatch();
  const { visible, selectedCamera, cameraShowType } = useAppSelector((state) => state.camera);
  const { zone } = useAppSelector((state) => state.zones);
  const { survayLayer } = useAppSelector((state) => state.layers);

  const { data } = useCameras();

  const cameraMarkers = useMemo(() => {
    return data?.map((item: any) => {
      if (!item.dev) return;
      const camera = JSON.parse(`{${item.dev}}`);
      if (!cameraShowType.includes(camera.Status)) return;
      const camearData = CAMERA_TYPES.filter((c) => c.type === camera.MethodCode)[0];

      const cameraIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${27 + Math.log10(camera.TTO + 1) * 3}px`,
            height: `${27 + Math.log10(camera.TTO + 1) * 3}px`,
            backgroundColor: camera.Status === "1" ? "#fffd" : "#eeed",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: camera.Status === "1" ? "#62b362cc" : "#f18282cc",
            display: "grid",
            placeItems: "center",
            fontSize: `${20 + Math.log10(camera.TTO + 1) * 5}px`,
            color: "#666",
          }}
        >
          <img src={camearData?.imgSrc} alt="test" style={{ width: "28px" }} />
        </Box>
      );

      const cameraIcon = divIcon({
        html: cameraIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
        iconAnchor: [18, 30],
      });

      const events = {
        click: () => {
          if (selectedCamera[0]?.DeviceCode === camera.DeviceCode) {
            dispatch(selectCamera([]));
          } else {
            dispatch(selectCamera([camera]));
          }
          dispatch(
            createTrafficAnalysisStarUrl([
              `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=54c0cd88-12de-4c51-8685-c44b92b737d6&paramvalues={"6fdfaf88-4f4a-cc25-ecaf-2da853c48f65":[{"Value":{"Id":"${camera?.DeviceCode}","Value":${camera?.DeviceCode},"DisplayValue":${camera?.DeviceCode}},"FromColumn":false,"SelectedField":null}]}`,
              `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e2ffa658-2244-4b16-99d4-2f5e11e39bfb&paramvalues={"6fdfaf88-4f4a-cc25-ecaf-2da853c48f65":[{"Value":{"Id":${camera?.DeviceCode},"Value":${camera?.DeviceCode},"DisplayValue":${camera?.DeviceCode}},"FromColumn":false,"SelectedField":null}]}`,
            ])
          );
        },
      };

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }} className="fa-number">
            <Stack alignItems="center">
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography> {camera.DeviceName} </Typography>
                <Typography> : نام سامانه </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                {" "}
                <Typography> {camera.TTO}</Typography>
                <Typography> : تعداد</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{camera.MethodName}</Typography>
                <Typography> : نوع سامانه</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{camera?.DeviceCode}</Typography>
                <Typography> : کد سامانه</Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{camera.PoliceCode} </Typography>
                <Typography> : کد پلیس </Typography>
              </Stack>
              <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
                <Typography>{camera.CompanyName}</Typography>
                <Typography> : نام شرکت</Typography>
              </Stack>
            </Stack>
          </Card>
        </Tooltip>
      );

      return (
        <>
          <Marker
            key={`camera-${item.id}`}
            position={[camera.GeographicalAccident, camera.GeographicalLength]}
            icon={cameraIcon}
            eventHandlers={events}
          >
            {tooltipContent}
          </Marker>
        </>
      );
    });
  }, [data, visible, cameraShowType]);

  const selectedCameraMarkers = useMemo(() => {
    return selectedCamera?.map((camera: any) => {
      const camearData = CAMERA_TYPES.filter((c) => c.type === camera.MethodCode)[0];

      const cameraIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${27 + Math.log10(camera.TTO + 1) * 3}px`,
            height: `${27 + Math.log10(camera.TTO + 1) * 3}px`,
            backgroundColor: camera.Status === "1" ? "#fffd" : "#eeed",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: camera.Status === "1" ? "#62b362cc" : "#f18282cc",
            display: "grid",
            placeItems: "center",
            fontSize: `${20 + Math.log10(camera.TTO + 1) * 5}px`,
            color: "#666",
          }}
        >
          <img src={camearData?.imgSrc} alt="test" style={{ width: "28px" }} />
        </Box>
      );

      const cameraIcon = divIcon({
        html: cameraIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
        iconAnchor: [18, 30],
      });

      const events = {
        click: () => {
          if (selectedCamera[0]?.DeviceCode === camera.DeviceCode) {
            dispatch(selectCamera([]));
          } else {
            dispatch(selectCamera([camera]));
          }
          dispatch(
            createTrafficAnalysisStarUrl([
              `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=25c862a7-9341-454d-b113-10c77f41d1c6&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
              `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e6543d83-0368-4915-93c6-175e6998ed78&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
            ])
          );
        },
      };

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }}>
            <Stack alignItems="flex-end">
              <Stack direction="row" sx={{ justifyContent: "space-between", width: "100%" }}>
                <Typography>نام سامانه : </Typography>
                <Typography className="fa-number" sx={{ m: "0 !important" }}>
                  {camera.DeviceName}
                </Typography>
              </Stack>
              <Typography> تعداد : {camera.TTO}</Typography>
              <Typography>نوع سامانه : {camera.MethodName}</Typography>
              <Typography>کد سامانه : {camera?.DeviceCode}</Typography>
              <Typography>کد پلیس : {camera.PoliceCode} </Typography>
              <Typography>نام شرکت : {camera.CompanyName}</Typography>
            </Stack>
          </Card>
        </Tooltip>
      );

      return (
        <>
          <Marker
            key={`camera-${camera.id}`}
            position={[camera.GeographicalAccident, camera.GeographicalLength]}
            icon={cameraIcon}
            eventHandlers={events}
          >
            {tooltipContent}
          </Marker>
        </>
      );
    });
  }, [selectedCamera, visible]);

  const handleSetSourceClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small source-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium source-m";
    }
    return "marker-cluster marker-cluster-large source-l";
  };

  const createSourceCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetSourceClass(cluster.getChildCount()),
      iconSize: point(40, 40, true),
    });
  }, []);

  if (!visible) return <></>;
  return (
    <>
      {selectedCamera.length > 0 ? (
        selectedCameraMarkers
      ) : (
        <Pane name={`${Math.random()}show_camera_marker`} style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
          <MarkerClusterGroup chunkedLoading maxClusterRadius={50} iconCreateFunction={createSourceCustomIcon}>
            {cameraMarkers}
          </MarkerClusterGroup>
        </Pane>
      )}
    </>
  );
}
